import { authApi } from './api';

export const resetOnLogOutMatcher = <T>(initialState: T) =>
  [authApi.endpoints.logOut.matchFulfilled, () => initialState] as const;
